// Mirrors the Level 1-3 palette already used by the hierarchy dialogs, the
// override breakdown and the commission tool, so a milestone card reads as the
// same family as the level it corresponds to.
const LEVEL_PALETTES = {
	L1: {
		level: "L1",
		deep: "#006064",
		main: "#00ACC1",
		light: "#80DEEA",
		bg: "#E0F7FA",
		confetti: ["#006064", "#00ACC1", "#4DD0E1", "#80DEEA", "#F4A11A", "#FFFFFF"],
	},
	L2: {
		level: "L2",
		deep: "#1565C0",
		main: "#1976D2",
		light: "#90CAF9",
		bg: "#E3F2FD",
		confetti: ["#1565C0", "#1976D2", "#42A5F5", "#90CAF9", "#F4A11A", "#FFFFFF"],
	},
	L3: {
		level: "L3",
		deep: "#4527A0",
		main: "#7E57C2",
		light: "#CE93D8",
		bg: "#EDE7F6",
		confetti: ["#4527A0", "#7E57C2", "#9575CD", "#CE93D8", "#F4A11A", "#FFFFFF"],
	},
};

// Climbing the ladder walks the palette down the level numbers: the entry
// milestone wears L3, the top one wears L1.
const TARGET_TO_LEVEL = {
	500: "L3",
	1000: "L2",
	2000: "L1",
};

export const getMilestonePalette = (target) => LEVEL_PALETTES[TARGET_TO_LEVEL[Number(target)]] ?? LEVEL_PALETTES.L3;

export default LEVEL_PALETTES;
